import React, { useId, useState } from "react";
import { getBirthDateAge } from "../../utils/birthDate";

const MONTHS = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
const controlClass = "w-full min-w-0 min-h-[3.25rem] px-3 py-3 bg-gray-100 border border-gray-200 rounded-lg text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-900";

// Direct year entry and native month/day menus avoid month-by-month calendar navigation.
const BirthDateField = ({ value, onChange, label = "Fecha de nacimiento*", autoComplete = true }) => {
  const id = useId();
  const [parts, setParts] = useState(() => {
    const [year = "", month = "", day = ""] = (value || "").split("-");
    return { year, month, day };
  });
  const update = (key, nextValue) => {
    const next = { ...parts, [key]: nextValue };
    setParts(next);
    const candidate = `${next.year.padStart(4, "0")}-${next.month}-${next.day}`;
    onChange(getBirthDateAge(candidate) === null ? "" : candidate);
  };
  const complete = parts.year && parts.month && parts.day;
  const invalid = complete && !value;
  return (
    <fieldset aria-describedby={`${id}-hint`}>
      <legend className="mb-2 text-sm font-medium text-gray-800">{label}</legend>
      <div className="grid grid-cols-3 gap-2">
        <label className="min-w-0 text-sm text-gray-700" htmlFor={`${id}-year`}>
          Año
          <input id={`${id}-year`} type="number" inputMode="numeric" autoComplete={autoComplete ? "bday-year" : "off"} min="1" max={new Date().getFullYear()} placeholder="AAAA" required value={parts.year} onChange={(e) => update("year", e.target.value)} className={controlClass} aria-invalid={Boolean(invalid)} />
        </label>
        <label className="min-w-0 text-sm text-gray-700" htmlFor={`${id}-month`}>
          Mes
          <select id={`${id}-month`} autoComplete={autoComplete ? "bday-month" : "off"} required value={parts.month} onChange={(e) => update("month", e.target.value)} className={controlClass}>
            <option value="">Mes</option>
            {MONTHS.map((month, index) => <option key={month} value={String(index + 1).padStart(2, "0")}>{month}</option>)}
          </select>
        </label>
        <label className="min-w-0 text-sm text-gray-700" htmlFor={`${id}-day`}>
          Día
          <select id={`${id}-day`} autoComplete={autoComplete ? "bday-day" : "off"} required value={parts.day} onChange={(e) => update("day", e.target.value)} className={controlClass}>
            <option value="">Día</option>
            {Array.from({ length: 31 }, (_, index) => <option key={index} value={String(index + 1).padStart(2, "0")}>{index + 1}</option>)}
          </select>
        </label>
      </div>
      <p id={`${id}-hint`} className="mt-2 text-sm text-gray-700" aria-live="polite">
        {invalid ? "Introduce una fecha válida que no sea futura." : "Escribe el año y elige el mes y el día."}
      </p>
    </fieldset>
  );
};

export default BirthDateField;
